export default {
  common: {
    actions: "操作",
    view: "查看",
    edit: "编辑",
    delete: "删除",
    manage: "管理",
    preview: "预览",
    clear: "清空",
    confirm: "确定",
    submit: "提交",
    next: "下一步",
    back: "返回",
    save: "保存",
    reset: "重置",
    cancel: "取消",
    find: "查找",
    refresh: "刷新",
    resend_email: "重新发送电子邮箱",
    upload: "上传",
    add: "添加",
    prompt: "提示",
    ok: "确认",
    continue: "继续",
    update: "更新",
    apply: "申请",
    previous: "上一步",
    type: "类型",
    success: "成功",
    fail: "失败",
    no_data: "无数据",
    start_time: "开始时间",
    end_time: "结束时间",
    per_page: "每页记录数",
    yes: "是的",
    start_date: "开始日期",
    end_date: "结束日期",
    login: "登录",
    password: "密码",
    email: "邮箱",
    welcome: "欢迎",
    search: "搜索",
    pending: "正在执行",
    created: "已创建",
    device_deleted: "设备已删除",
    in_query: "查询中",
    no_options: "无数据",
    enter: "输入",
    noresult: "未找到记录",
    system_default: "系统默认",
    personal_template: "个人模板",
    otaUpdata: "OTA 升级",
    is: "是",
    is_not: "否",
    light_setting: "灯光控制",
    advGroup: "价签广播组",
    turn_off: "关闭",
    Blue: "蓝色",
    Green: "绿色",
    Red: "红色",
    Yellow: "黄色",
    White: "白色",
    Pink: "粉色",
    Cyan: "青色",
    device_advgroup: "网关广播组",
    common_form_get_code_surplus: "秒后重新发送",
    common_form_get_code: "重新下发",
    new_password: "新密码",
    confirm_password: "确认密码",
    set_password: "设置密码",
    column_manager: "列管理",
    common_mismatched: "密码不一致",
    common_password_enter: "请输入新密码",
    common_confirm_password_enter: "请输入确认密码",
    account_remote_login: "账号异地登录，请重新登录",

  },

  dictionary: {
    vertical: "垂直",
    horizontal: "水平",
    generaluse: "通用",
    discount: "折扣",
    byunit: "按单位",
    by_value: "按价值",
    promotion: "促销活动",
  },

  month: {
    january: "1 月",
    february: "2 月",
    march: "3 月",
    April: "4 月",
    May: "5 月",
    June: "6 月",
    July: "7 月",
    August: "8 月",
    September: "9 月",
    October: "10 月",
    November: "11 月",
    December: "12 月",
  },

  zoontime: {
    International: "(GMT-12:00) 国际日期变更线西",
    Coordinated: "(UTC-11) 协调世界时-11",
    Hawaii: "(UTC-10) 夏威夷",
    Alaska: "(UTC-9) 阿拉斯加",
    California: "(UTC-8) 太平洋时间（美洲和加拿大）下加利福尼亚",
    Arizona: "(UTC-7) 拉巴斯，山地时间（美洲和加拿大），亚利桑那州",
    America: "(UTC-6) 萨斯喀彻温省，中央时间，中美洲",
    Eastern:
      "(UTC-5) 波哥大，利马，基多，里约布兰科，东部时间，印第安纳州（东部）",
    Caracas: "(UTC-4:30) 加拉加斯",
    Atlantic: "(UTC-4) 大西洋时间，库亚巴，乔治敦，拉巴斯，圣地亚哥",
    Newfoundland: "(UTC-3:30) 纽芬兰",
    Brasilia: "(UTC-3) 巴西利亚，布宜诺斯艾利斯，格林兰，凯恩",
    International2: "(UTC-2) 国际日期变更线西-02",
    Azores: "(UTC-1) 佛得角群岛，亚速尔群岛",
    Edinburgh: "(UTC) 都柏林，爱丁堡，里斯本，伦敦，国际日期变更线西",
    Brussels: "(UTC+1) 阿姆斯特丹，布鲁塞尔，萨拉热窝",
    Damascus: "(UTC+2) 贝鲁特，大马士革，东欧，开罗，雅典，耶路撒冷",
    Kuwait: "(UTC+3) 巴格达，科威特，莫斯科，圣彼得堡，内罗毕",
    Tehran: "(UTC+3:30) 德黑兰",
    Yerevan: "(UTC+4)阿布扎比，埃里温，巴库，路易港，萨马拉",
    Kabul: "(UTC+4:30) 喀布尔",
    Karachi: "(UTC+5) 阿什哈巴德，伊斯兰堡，卡拉奇",
    Calcutta: "(UTC+5:30) 金奈，加尔各答，孟买，新德里",
    Kathmandu: "(UTC+5:45) 加德满都",
    Novosibirsk: "(UTC+6) 阿斯塔纳，达卡，新西伯利亚",
    Yangon: "(UTC+6:30) 仰光",
    Jakarta: "(UTC+7) 曼谷，河内，雅加达",
    Beijing: "(UTC+08:00) 北京，重庆，香港，乌鲁木齐，吉隆坡，新加坡",
    Yakutsk: "(UTC+9) 大阪，东京，首尔，雅库茨克",
    Adelaide: "(UTC+9:30) 阿德莱德，达尔文",
    Canberra: "(UTC+10) 布里斯班，符拉迪沃斯托克，关岛，堪培拉",
    Islands: "(UTC+11) 所罗门群岛，新喀里多尼亚",
    Oakland: "(UTC+12) 阿纳德尔，奥克兰，惠灵顿，斐济",
    alofa: "(UTC+13) 努库阿洛法，萨摩亚群岛",
    Island: "(UTC+14) 圣诞岛",
  },
};
